import React from "react";
import { Sparkles, Lock } from "lucide-react";

// Points balance + redeemable rewards. Locked tiles show how many points remain.
export function RewardsCatalog({ points, rewards, onRedeem }) {
  return (
    <div data-testid="rewards-catalog">
      <div className="bg-gradient-to-br from-espresso to-[#3a2f28] text-ivory rounded-2xl p-8 mb-8 flex items-center justify-between">
        <div>
          <div className="overline !text-brass mb-2">Your Balance</div>
          <div className="font-serif text-5xl lg:text-6xl" data-testid="points-balance">{points.toLocaleString()}</div>
          <div className="text-ivory/50 text-sm mt-1">reward points</div>
        </div>
        <Sparkles className="text-brass" size={56} strokeWidth={1.2} />
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(rewards || []).map((r) => {
          const affordable = points >= r.cost;
          return (
            <div key={r.id} data-testid={`reward-${r.id}`} className={`rounded-xl border p-6 flex flex-col ${affordable ? "border-brass/50 bg-linen" : "border-espresso/10 bg-ivory"}`}>
              <div className="flex items-start justify-between mb-4">
                <div className="overline">{r.type}</div>
                {!affordable && <Lock size={15} className="text-taupe" />}
              </div>
              <h4 className="font-serif text-2xl text-espresso leading-tight">{r.name}</h4>
              <div className="mt-4 mb-6 text-sm text-taupe">{r.cost.toLocaleString()} points</div>
              <button
                data-testid={`redeem-${r.id}`}
                disabled={!affordable}
                onClick={() => onRedeem(r)}
                className={`mt-auto w-full rounded-full py-3 text-xs uppercase tracking-[0.18em] transition-all ${
                  affordable ? "bg-espresso text-ivory hover:bg-brass" : "bg-espresso/5 text-taupe cursor-not-allowed"
                }`}
              >
                {affordable ? "Redeem" : `${(r.cost - points).toLocaleString()} pts to go`}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
